import { useQuery } from 'react-query'
import { dataUseCase } from '../../factories'

const useGetDataWithType = (type) => {
  const {
    refetch,
    isLoading,
    isFetching,
    data: dataWithType,
    error,
  } = useQuery('dataWithType', () => dataUseCase.getDataWithType(type), {refetchOnWindowFocus: false})

  return {
    refetch,
    isFetching,
    isLoading,
    error,
    dataWithType,
  }
}

export default useGetDataWithType
